import Http from '@/services/http'
import Endpoints from '@/services/http/endpoints'
import { ApiEndpoints } from '@/types/backend'
import { type EditionStageResponse } from '@/schemas/edititionStage'

export default {
  fetchEditionStage() {
    return Http.get<EditionStageResponse>(Endpoints.get(ApiEndpoints.editionStage))
  }
}
